export const HEIGHT_OF_HEADER_FOOTER = '134px';
